import React, {useContext} from "react";
import "./index.scss";
import UserContext from "../user/context/UserContext";



function Header() {

    const {
        current,
        fetch,
        authenticate,
        logout,
    } = useContext(UserContext);
    return <div className="main-header">
        <div className="main-header-inner">
            <a href="//niu.niuxyx.com/"
               className="main-header-logo"
               target="_blank"
               title="牛X页游"
            />
            <div className={"main-header-nav"}>

            </div>
            {/*<h1 className={""}>*/}

            {/*</h1>*/}
            {/*<div className="game">*/}
            {/*    <h2></h2>*/}
            {/*</div>*/}
            {/*<ul className="head_link">*/}

            {/*</ul>*/}
            <div className="main-header-user">
                {current ? <>
                    欢迎您：{current?.username}
                    <a href={"javascript:;"} onClick={() => {
                        logout();
                    }}>[退出]</a>
                </> : <>
                    <a href={"javascript:;"} onClick={() => {
                        authenticate();
                    }}>登录</a>
                </>}


                {/*<div className="box unlogin" id="headdiv">*/}
                {/*    */}
                {/*</div>*/}
            </div>
        </div>
    </div>
}

export default Header;